const region = "us-east-1";
const origin = window.location.origin;

const demo = {
  appSettingsData: {
    // generate a file format limit of video file
    federatedEngageAIProvider: "wl-idp-dev-engage-gpt-ident-prov",
  },

  amplify_config: {
    Auth: {
      mandatorySignIn: true,
      region: region,
      userPoolId: "us-east-1_wJGyDVS8j",
      userPoolWebClientId: "4cvm60rrak8ia06274md1v5ljq",
    },
    oauth: {
      domain: "auth.dev.gpt.wl-engage.com",
      scope: [],
      redirectSignIn: `${origin}/chat`,
      redirectSignOut: `${origin}/chat`,
      responseType: "code",
      clientId: "4cvm60rrak8ia06274md1v5ljq",
    },
    API: {
      endpoints: [
        {
          name: "engage-gpt",
          // endpoint: "https://api.dev.wl-dms.com",
          endpoint: "https://api.dev.gpt.wl-engage.com",
          region: region,
        },
      ],
    },
  },
};
// type demoType = typeof demo

export type DemoType = typeof demo;
export default demo;
